export const SET_DATA = 'sunModel/SET_DATA';
export const UNLOAD_DATA = 'sunModel/UNLOAD_DATA';
export const ADD_FACT_TABLE = 'sunModel/ADD_FACT_TABLE';
export const UPDATE_FACT_TABLE = 'sunModel/UPDATE_FACT_TABLE';
export const ADD_DIMENSION = 'sunModel/ADD_DIMENSION';
export const UPDATE_DIMENSION = 'sunModel/UPDATE_DIMENSION';
export const ADD_LINK = 'sunModel/ADD_LINK';
export const SET_SUN_MODEL_LOADING = 'sunModel/SET_SUN_MODEL_LOADING';
export const SET_DIMENSION_MODAL_LOADING = 'sunModel/SET_DIMENSION_MODAL_LOADING';
export const SET_FACT_MODAL_LOADING = 'sunModel/SET_FACT_MODAL_LOADING';
export const SHOW_FACT_MODAL = 'sunModel/SHOW_FACT_MODAL';
export const SHOW_DIMENSION_MODAL = 'sunModel/SHOW_DIMENSION_MODAL';
export const SHOW_LINK_MODAL = 'sunModel/SHOW_LINK_MODAL';
export const HIDE_FACT_MODAL = 'sunModel/HIDE_FACT_MODAL';
export const HIDE_DIMENSION_MODAL = 'sunModel/HIDE_DIMENSION_MODAL';
export const HIDE_LINK_MODAL = 'sunModel/HIDE_LINK_MODAL';
export const SHOW_OPTIONS_MODAL = 'sunModel/SHOW_OPTIONS_MODAL';
export const HIDE_OPTIONS_MODAL = 'sunModel/HIDE_OPTIONS_MODAL';
export const SET_FILTER = 'sunModel/SET_FILTER';
export const SET_ORIGINAL_DATA = 'sunModel/SET_ORIGINAL_DATA';
export const SET_LINK_MODAL_LOADING = 'sunModel/SET_LINK_MODAL_LOADING';
export const RESET_DIMENSION_MODAL = 'sunModel/RESET_DIMENSION_MODAL';
export const RESET_FACT_MODAL = 'sunModel/RESET_FACT_MODAL';
export const SET_LINK_DIMENSION = 'sunModel/SET_LINK_DIMENSION';
export const SET_LINK_FACT = 'sunModel/SET_LINK_FACT';
export const HIDE_MEASURES_MODAL = 'sunModel/HIDE_MEASURES_MODAL';
export const SHOW_MEASURES_MODAL = 'sunModel/SHOW_MEASURES_MODAL';
export const SET_MEASURES_MODAL_LOADING = 'sunModel/SET_MEASURES_MODAL_LOADING';
export const ADD_REASON = 'sunModel/ADD_REASON';
export const RESET_REASONS_MODAL = 'sunModel/RESET_REASONS_MODAL';
export const HIDE_ATTRIBUTES_MODAL = 'sunModel/HIDE_ATTRIBUTES_MODAL';
export const SHOW_ATTRIBUTES_MODAL = 'sunModel/SHOW_ATTRIBUTES_MODAL';
export const SET_ATTRIBUTES_MODAL_LOADING = 'sunModel/SET_ATTRIBUTES_MODAL_LOADING';
export const ADD_ATTRIBUTES = 'sunModel/ADD_ATTRIBUTES';
export const UPDATE_ATTRIBUTES = 'sunModel/UPDATE_ATTRIBUTES';
export const RESET_ATTRIBUTES_MODAL = 'sunModel/RESET_ATTRIBUTES_MODAL';
export const DELETE_ATTRIBUTE = 'sunModel/DELETE_ATTRIBUTE';
export const DELETE_MEASURE = 'sunModel/DELETE_MEASURE';
export const SET_CONFIRM_MODAL = 'sunModel/SET_CONFIRM_MODAL';
export const SET_REMOVE_ITEMS_MODAL = 'sunModel/SET_REMOVE_ITEMS_MODAL';
export const DELETE_DIMENSION = 'sunModel/DELETE_DIMENSION';
export const DELETE_LINK = 'sunModel/DELETE_LINK';
export const DELETE_FACT = 'sunModel/DELETE_FACT';

export const SET_AGGREGATION_TYPES = 'sunModel/SET_AGGREGATION_TYPES';
export const SET_DATA_TYPES = 'sunModel/SET_DATA_TYPES';
export const SET_SHOW_HIDE_ATTRIBUTES = 'sunModel/SET_SHOW_HIDE_ATTRIBUTES';
export const SET_SHOW_HIDE_MINOR_ELEMENTS = 'sunModel/SET_SHOW_HIDE_MINOR_ELEMENTS';

export const LOAD_REMOVE_MODAL = 'sunModel/LOAD_REMOVE_MODAL';

export const SHOW_SLIDER_MODAL = 'sunModel/SHOW_SLIDER_MODAL';
export const HIDE_SLIDER_MODAL = 'sunModel/HIDE_SLIDER_MODAL';

export const SHOW_TAGS_MODAL = 'sunModel/SHOW_TAGS_MODAL';
export const HIDE_TAGS_MODAL = 'sunModel/HIDE_TAGS_MODAL';

export const SET_TAGS = 'sunModel/SET_TAGS';
export const SET_TAGS_LOADING = 'sunModel/SET_TAGS_LOADING';
